import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  basePriceArs: number;
  isCrossedOut?: boolean;
  className?: string;
}
export function PriceDisplay({
  basePriceArs,
  isCrossedOut = false,
  className = ''
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`$${basePriceArs.toLocaleString('es-AR')}`);
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    const lowerLocale = locale.toLowerCase();
    // Conversion rates (approximate for demo purposes)
    // Base is ARS
    let currency = 'ARS';
    let symbol = '$';
    let price = basePriceArs;
    let formatLocale = 'es-AR';
    if (lowerLocale.startsWith('en-us') || lowerLocale.startsWith('en-ca')) {
      currency = 'USD';
      symbol = 'USD $';
      price = basePriceArs / 1000; // Fake conversion
      formatLocale = 'en-US';
    } else if (lowerLocale.startsWith('en-gb')) {
      currency = 'GBP';
      symbol = '£';
      price = basePriceArs / 1250;
      formatLocale = 'en-GB';
    } else if (lowerLocale.startsWith('de') || lowerLocale.startsWith('fr') || lowerLocale.startsWith('it') || lowerLocale === 'es-es' || lowerLocale.startsWith('pt-pt')) {
      currency = 'EUR';
      symbol = '€';
      price = basePriceArs / 1100;
      formatLocale = 'de-DE';
    } else if (lowerLocale.startsWith('pt-br')) {
      currency = 'BRL';
      symbol = 'R$';
      price = basePriceArs / 200;
      formatLocale = 'pt-BR';
    } else if (!lowerLocale.startsWith('es')) {
      // Default fallback for non-spanish
      currency = 'USD';
      symbol = 'USD $';
      price = basePriceArs / 1000;
      formatLocale = 'en-US';
    }
    // Format the number
    const formatted = new Intl.NumberFormat(formatLocale, {
      minimumFractionDigits: currency === 'ARS' ? 0 : 2,
      maximumFractionDigits: currency === 'ARS' ? 0 : 2
    }).format(price);
    setFormattedPrice(`${symbol}${formatted}`);
  }, [basePriceArs]);
  return <span className={`${isCrossedOut ? 'line-through opacity-60' : 'font-bold'} ${className}`} data-id="element-117">
      {formattedPrice}
    </span>;
}